module.exports = __webpack_public_path__ + "img/schedule.80af6ff5.svg";